<template>
    <!-- Loading Data... -->
    <div class="tile is-ancestor is-full-height">
        <div class="tile is-parent">
            <div class="tile is-child">
                <b-table
                        :loading=true>
                </b-table>
                <p class="is-size-5 has-text-centered">Loading result....</p>
            </div>
        </div>
    </div>
    <!-- Loading Data end -->
</template>

<script>
    export default {
        name: "Loading"
    }
</script>

<style scoped>

</style>